import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { listScholarships } from "../../models/fieldSettings";
import { lowerCase, momentDate, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const StepFour = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [scholarships, setScholarships] = useState([]);
  const [selectedScholarship, setSelectedScholarship] = useState("");

  useEffect(() => {
    context.setLoader(true);
    listScholarships("1").then((res) => {
      if (res) setScholarships(res);
      context.setLoader(false);
    });
  }, []);

  useEffect(() => {
    if (props.dataSource)
      setSelectedScholarship(props.dataSource.is_scholarship_holder);
  }, [props.dataSource]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      Toast.show({ content: "Please fill all the required fields" });
      return;
    }
    Dialog.confirm({
      content: "Do you want to update?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        updateProfilee(form);
      },
    });
  };

  const updateProfilee = (form) => {
    context.setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.UPDATE_PROFILE_STEP_FOUR, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          if (props.onSuccess) props.onSuccess();

          Toast.show({
            content: res["data"].message || "Updated",
            icon: "success",
          });
          context.setStorage("setp_three", "yes");
          context.setStorage("update_stu_data", "");
          context.setStorage("setp_one", "");
          context.setStorage("setp_two", "");
          context.setStorage("setp_three", "");
          context.setStorage("setp_four", "");
          context.setStorage("update_stu_profile", "no");
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        context.setLoader(false);
      });
  };

  const maxDate = () => {
    let y = momentDate(new Date(), "YYYY") - 16;
    let d = momentDate(new Date(), "DD");
    let m = momentDate(new Date(), "MM");
    return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
  };

  const studentData = (fieldName) => {
    let d = context.getStorage("update_stu_data");
    if (d) d = JSON.parse(d);
    return d?.[fieldName];
  };

  const field = (fieldName) => {
    let m = props.dataSource;
    return m?.[fieldName];
  };

  return (
    <>
      <Form
        action=""
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="uuid" value={studentData("uuid")} />
        <input
          type="hidden"
          name="registerno"
          value={studentData("registerno")}
        />

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Scholarship Details
        </div>
        <div className="container py-2">
          <Row className="">
            <Col md={4} sm={4} xs={4}>
              <label>
                Scholarship <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                as="select"
                size="sm"
                className="fw-bold"
                name="is_scholarship_holder"
                onChange={(e) => setSelectedScholarship(e.target.value)}
                required
              >
                <option value="">-Select-</option>
                <option value="0">None</option>
                {scholarships.map((item) => (
                  <option
                    value={item.id}
                    selected={
                      field("is_scholarship_holder") == item.id
                        ? "selected"
                        : ""
                    }
                  >
                    {item.scholarship_name}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Aadhar No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold bg-light"
                name="aadharno"
                value={field("aadharno")}
                required
              />
            </Col>
          </Row>

          {upperCase(field("community_name")) != "OC" &&
            selectedScholarship != 5 &&
            selectedScholarship != 6 && (
              <Row className="mt-2">
                <Col md={4} sm={4} xs={4}>
                  <label>
                    Community Certificate No{" "}
                    <span className="text-danger">*</span>
                  </label>
                </Col>
                <Col md={8} sm={8} xs={8}>
                  <Form.Control
                    type="text"
                    size="sm"
                    className="fw-bold bg-light"
                    name="community_certificate_no"
                    value={field("community_certificate_no")}
                    required
                  />
                </Col>
              </Row>
            )}

          {(selectedScholarship == 1 || selectedScholarship == 2) && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Income Certificate No <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="income_certificate_no"
                  defaultValue={field("income_certificate_no")}
                  required
                />
              </Col>
            </Row>
          )}

          {(selectedScholarship == 1 || selectedScholarship == 2) && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  SSL Marksheet No <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="sslc_marksheet_no"
                  defaultValue={field("sslc_marksheet_no")}
                  required
                />
              </Col>
            </Row>
          )}

          {(selectedScholarship == 1 || selectedScholarship == 2) && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  HSC Marksheet No <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="hsc_marksheet_no"
                  defaultValue={field("hsc_marksheet_no")}
                  required
                />
              </Col>
            </Row>
          )}

          {selectedScholarship == 4 && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  First Graduate Certificate No
                  <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="first_graduate_certificate_no"
                  defaultValue={field("first_graduate_certificate_no")}
                  required
                />
              </Col>
            </Row>
          )}

          {selectedScholarship == 5 && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Physical Certificate No
                  <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="physical_certificate_no"
                  defaultValue={field("physical_certificate_no")}
                  required
                />
              </Col>
            </Row>
          )}

          {selectedScholarship == 6 && (
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>
                  Tamil Medium Certificate No
                  <span className="text-danger">*</span>
                </label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  name="tamil_medium_certificate_no"
                  defaultValue={field("tamil_medium_certificate_no")}
                  required
                />
              </Col>
            </Row>
          )}
        </div>

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Other Details
        </div>
        <div className="container py-2">
          <Row className="">
            <Col md={8} sm={8} xs={8}>
              <label>
                Do you have any physical disabilities ?
                <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={4} sm={4} xs={4}>
              <span className="float-end">
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  className="check-input-lg"
                  name="is_physicall_challenged"
                  defaultChecked={field("is_physicall_challenged") == "1"}
                  value="1"
                />
              </span>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={8} sm={8} xs={8}>
              <label>
                Are you{" "}
                {field("gender")
                  ? lowerCase(field("gender")) == "male"
                    ? "Son of"
                    : "Daughter of"
                  : "child of"}{" "}
                an Ex-Serviceman ?<span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={4} sm={4} xs={4}>
              <span className="float-end">
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  className="check-input-lg"
                  name="is_exserviceman"
                  defaultChecked={field("is_exserviceman") == "1"}
                  value="1"
                />
              </span>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={8} sm={8} xs={8}>
              <label>
                Are you a hosteller ?<span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={4} sm={4} xs={4}>
              <span className="float-end">
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  className="check-input-lg"
                  name="is_hosteller"
                  defaultChecked={field("is_hosteller") == "1"}
                  value="1"
                />
              </span>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={8} sm={8} xs={8}>
              <label>
                Do you participate in any sports or athletic activities?
                (District, state and National level only)
                <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={4} sm={4} xs={4}>
              <span className="float-end">
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  className="check-input-lg"
                  name="is_sportsman"
                  defaultChecked={field("is_sportsman") == "1"}
                  value="1"
                />
              </span>
            </Col>
          </Row>
        </div>

        <div className="container py-3">
          <Row>
            <Col md={12}>
              <Button
                type="submit"
                variant="warning"
                className="w-100"
                size="lg"
              >
                Save & Continue
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
    </>
  );
};
export default StepFour;
